import * as Notifications from 'react-notification-system-redux'
import { NotificationLevel } from 'react-notification-system-redux'

export function errorToast(title: string, message: string, options = {}) {
  return createNotification('error', title, message, options)
}

export function infoToast(title: string, message: string, options = {}) {
  return createNotification('info', title, message, options)
}

export function successToast(title: string, message: string, options = {}) {
  return createNotification('success', title, message, options)
}

export function warningToast(title: string, message: string, options = {}) {
  return createNotification('warning', title, message, options)
}

function createNotification(
  level: NotificationLevel,
  title: string,
  message: string,
  options = {},
) {
  const opts = Object.assign({}, options) as any
  opts.autoDismiss = level === 'success' ? 2 : 5

  return Notifications.show(
    {
      message,
      title,
      ...opts,
    },
    level,
  )
}
